export enum DischargePlanningFormField {
  DISCHARGE_PLANNING_DISCHARGE_PLANS = 'dischargePlans',
  DISCHARGE_PLANNING_REHABILITATION_POTENTIAL = 'dischargePlanningRehabilitationPotential',
  DISCHARGE_PLANNING_NOTES = 'dischargePlanningNotes'
}
